import { AboutUsContainer } from "./style";

const About = () => {
  return (
    <AboutUsContainer>
      <div>
        <h1>About Us</h1>
        <p>
        At Blushawk, we're dedicated to provide a door-to-door delivery service across chennai. We specialize in offering last-mile delivery solutions exclusively for live fishes, ensuring affordable price and high care.
        </p>
      </div>
      <div>
        <h1>Our Vision</h1>
        <p>
          We’re here to revolutionize the way pets are shipped across the world
          and expand access to the global market. We aim to cater specialized
          delivery services for the entire pet industry.
        </p>
      </div>
      <div>
        <h1>Our Mission</h1>
        <p>
          We're currently transforming live fish shipping with innovative,
          specialized delivery methods. Our mission is to provide cost-effective
          solutions to meet the needs of hobbyists and business owners in the
          ornamental fish industry.
        </p>
      </div>
      <h2>
        Ready to ship with Blushawk? Explore our services or get in touch today!
      </h2>
    </AboutUsContainer>
  );
};

export default About;

